
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$localized-input.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$localized-input.js';
export default __default__;
